// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3RS_F","fileBtn":"File_fileBtn__2h0bN","closeBtn":"File_closeBtn__2b6HF","fileSelected":"File_fileSelected__hk1SS","disabled":"File_disabled__1ZK7K"};